import { Button, IconButton, Typography } from "@mui/material";
import { CrossIcon } from "../Plans/icons/GPTIcons/CrossIcon";
import { capitalizeFirstChar } from "../../helpers";
import ModalWrapper from "./Modal";

type WarningModalProps = {
  open: boolean;
  handleExit: () => void;
  handleCloseWarning: () => void;
  mainText: string;
  subText?: string;
  warningType?: string;
};
const WarningModal = ({ open, handleExit, handleCloseWarning, mainText, subText = "Your changes will be lost if you close this window now.", warningType = "Return" }: WarningModalProps) => {
  return (
    <ModalWrapper open={open} wrapperClassName="md:w-modal-lg" className="p-6 bg-white dark:bg-background/paper-elevation-16">
      <div className="flex flex-col gap-y-6">
        <div className="flex justify-between items-center">
          <Typography variant="h6/medium-500" className="text-mui-black-87 dark:text-white">
            {mainText}
          </Typography>
          <IconButton
            size="small"
            onClick={handleCloseWarning}
            className="cross-icon"
          >
            <CrossIcon className="fill-current" />
          </IconButton>
        </div>

        <>
          <div className="text-sm">
            {subText}
          </div>
          <div className="flex flex-col gap-y-4 md:flex-row gap-x-6 justify-center">
            <Button
              variant="contained"
              color="error"
              size="large"
              fullWidth
              className="!bg-error-main !normal-case"
              onClick={handleExit}
            >
              Close & Discard Changes
            </Button>
            <Button
              variant="outlined"
              color="inherit"
              size="large"
              fullWidth
              className="button-outlined"
              onClick={handleCloseWarning}
            >
              Return to
              {" "}
              {capitalizeFirstChar(warningType)}
            </Button>
          </div>
        </>
      </div>
    </ModalWrapper>
  );
};

export default WarningModal;
